import React from "react";

export default function SummaryCard({
  label,
  value,
  accent,
  icon,
  maskIcon,    // 라인아트 PNG 경로 — iconColor로 색 틴트
  iconColor,   // maskIcon 색(hex)
  imgIcon,     // 일반 이미지 경로(원본 색 그대로)
  compact = false,
}) {
  const boxClass = `flex shrink-0 items-center justify-center rounded-2xl bg-gray-50 leading-none dark:bg-white/5 ${
    compact ? "h-11 w-11" : "h-12 w-12"
  }`;
  const glyphSize = compact ? 24 : 28;

  return (
    <div
      className={`flex items-center gap-3 rounded-2xl border border-gray-100 bg-white shadow-[0_1px_3px_rgba(15,23,42,0.06)] transition hover:shadow-[0_6px_18px_rgba(15,23,42,0.08)] dark:border-white/10 dark:bg-[#111827] ${
        compact ? "p-3" : "p-4"
      }`}
    >
      {maskIcon ? (
        <div
          className={`flex shrink-0 items-center justify-center rounded-2xl leading-none ${
            compact ? "h-11 w-11" : "h-12 w-12"
          }`}
          style={{ backgroundColor: (iconColor || "#64748B") + "40" }}
        >
          <span
            aria-hidden="true"
            style={{
              display: "block",
              width: glyphSize,
              height: glyphSize,
              backgroundColor: iconColor || "#64748B",
              WebkitMaskImage: `url(${maskIcon})`,
              maskImage: `url(${maskIcon})`,
              WebkitMaskSize: "contain",
              maskSize: "contain",
              WebkitMaskRepeat: "no-repeat",
              maskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
              maskPosition: "center",
            }}
          />
        </div>
      ) : imgIcon ? (
        <div className={boxClass}>
          <img
            src={imgIcon}
            alt=""
            aria-hidden="true"
            style={{ width: glyphSize, height: glyphSize, objectFit: "contain" }}
          />
        </div>
      ) : icon ? (
        <div
          className={`${boxClass} ${accent} ${
            compact ? "text-2xl" : "text-[26px]"
          }`}
        >
          {icon}
        </div>
      ) : null}

      <div className="min-w-0 flex-1">
        <div className="truncate text-[13px] font-semibold text-gray-500 dark:text-gray-400">
          {label}
        </div>
        <div
          className={`mt-0.5 font-extrabold tracking-tight text-gray-900 dark:text-white ${
            compact ? "text-2xl" : "text-[26px]"
          }`}
        >
          {value}
        </div>
      </div>
    </div>
  );
}
